export default __webpack_public_path__ + "static/media/gallery-wip-emitter_01.471945c7.jpg";